import React, { ReactNode } from "react";
import { RadioGroup } from "../radio/Radio";

import classnames from "classnames";

import "./RadioOptions.scss";

interface RadioOptionsProps {
  selectedOption: string | number;
  name: string;
  onChange: (value: unknown) => void;
  legend: ReactNode;
  children: ReactNode;
  className?: string;
  disabled?: boolean;
  component?: ReactNode;
  error?: boolean;
}

export const RadioOptions = ({
  name,
  selectedOption,
  onChange,
  children,
  legend,
  className,
  disabled,
  component,
  error,
}: RadioOptionsProps) => {
  return (
    <fieldset className={classnames("radio-options", className)}>
      <legend className="radio-options__label">{legend}</legend>
      <RadioGroup
        selectedValue={selectedOption}
        onChange={onChange}
        name={name}
        disabled={disabled}
        Component={component}
        error={error}
      >
        {children}
      </RadioGroup>
    </fieldset>
  );
};
